import { animated, to, useSpring } from '@react-spring/web';
import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function FabIcon({
  open
}) {
  const firstDot = useSpring({
    height: open ? 20 : 4,
    rotation: open ? -45 : 0,
    x: open ? 1.515 : 8,
    y: open ? 4.343 : 0,
    from: {
      x: 8,
      y: 0,
      rotation: 0,
      height: 4
    }
  });
  const secondDot = useSpring({
    height: open ? 20 : 4,
    rotation: open ? 45 : 0,
    x: open ? 15.657 : 8,
    y: open ? 1.515 : 16,
    from: {
      x: 8,
      y: 16,
      rotation: 0,
      height: 4
    }
  });
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 20 20",
    children: [/*#__PURE__*/_jsx(animated.rect, {
      width: "4",
      height: firstDot.height,
      rx: "2",
      transform: to([firstDot.x, firstDot.y, firstDot.rotation], (x, y, rotation) => `translate(${x} ${y}) rotate(${rotation})`),
      fill: "#fff"
    }), /*#__PURE__*/_jsx(animated.rect, {
      width: "4",
      height: "4",
      rx: "2",
      transform: "translate(8 8)",
      fill: "#fff"
    }), /*#__PURE__*/_jsx(animated.rect, {
      width: "4",
      height: secondDot.height,
      rx: "2",
      transform: to([secondDot.x, secondDot.y, secondDot.rotation], (x, y, rotation) => `translate(${x} ${y}) rotate(${rotation})`),
      fill: "#fff"
    })]
  });
}